import { render, staticRenderFns } from "./intelligentService.vue?vue&type=template&id=28694179&scoped=true&"
import script from "./intelligentService.vue?vue&type=script&lang=js&"
export * from "./intelligentService.vue?vue&type=script&lang=js&"
import style0 from "./intelligentService.vue?vue&type=style&index=0&id=28694179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28694179",
  null
  
)

export default component.exports